
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { tablaMultas } from '../../../../shared/data/tables/tabla-multas';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import {  BehaviorSubject } from 'rxjs';
import { Component,HostListener,  OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { VehiclesService } from '../../../../shared/services/vehicles.service';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import { Utils } from '../../../../shared/utils/Utils';
const Swal = require("sweetalert2");
import { AuthService } from '../../../../shared/services/auth.service';
@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss']
})
export class GeneralComponent implements OnInit {
  public selected = [];
  public filteredTableItem$: BehaviorSubject<tablaMultas[]> = new BehaviorSubject<tablaMultas[]>([]); // Nuevo BehaviorSubject para filtrar
  public searchText: string = ''; // Texto de búsqueda

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  isSelected = false;

  disabled = true;
  selectedEstado: any;
  vehicles: any[] = [];
  tarjetas: any;

  onNavChange1(changeEvent: NgbNavChangeEvent) {
    if (changeEvent.nextId === 5) {
      changeEvent.preventDefault();
    }
  }



  public show : boolean = false
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' o 'desc'
  searchTerm: string = '';
  dropdownStates: boolean[] = [];
  filteredTableItems: VehiclesService[];
  

  constructor(
    private vehicleService: VehiclesService,
    private router: Router,
    public auth: AuthService
  
  ) {}

  ngOnInit() {
    this.selectedEstado="";
    this.listarGeneral();
    
  }

  pageSize1: number = 5; 
  page1: number = 1;
  totalItems: number;

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // Establecemos la columna y dirección de orden
   // this.service.sortColumn = column;
   // this.service.sortDirection = direction;
  }

 sortData(column: string): void {
  if (this.sortColumn === column) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }

  this.filteredTableItems.sort((a, b) => {
    const aValue = this.getValue(a, column);
    const bValue = this.getValue(b, column);

    if (aValue == null) return 1;
    if (bValue == null) return -1;

    if (typeof aValue === 'string') {
      return this.sortDirection === 'asc'
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }

    if (typeof aValue === 'number' || aValue instanceof Date) {
      return this.sortDirection === 'asc'
        ? aValue > bValue ? 1 : -1
        : bValue > aValue ? 1 : -1;
    }

    return 0;
  });
}

getValue(item: any, column: string): any {
  switch (column) {
    case 'placa': return item.placa;
    case 'interno': return item.interno;
    case 'marca': return item.marcas?.marca;
    case 'modelo': return item.modelo;
    case 'clase': return item.tipoVehiculo?.tipos;
    case 'cc': return item.Idpropietario;
    case 'propietario':
      return `${item.propietario?.primernombre ?? ''} ${item.propietario?.papellidos ?? ''}`;
    case 'relacion': return item.tipoRelacion?.relacion;
    case 'tarjetaOperacion': return new Date(item.tarjetasOperaciones?.[0]?.fecha_vencimiento ?? 0);
    case 'soat': return new Date(item.historialSoat?.[0]?.vencimiento_soat ?? 0);
    case 'cda': return new Date(item.estadoFechas?.historialCda?.[0]?.vcda ?? 0);
    case 'bimestral': return new Date(item.historialBimestral?.[0]?.proxima_revision ?? 0);
    case 'rcc': return new Date(item.historialContractual?.[0]?.fecha_vencimientoRCC ?? 0);
    case 'rce': return new Date(item.historialExtraContractual?.[0]?.fecha_vencimientoRCE ?? 0);
    default: return '';
  }
}
  get filteredinfracciones() {
    if (!this.searchTerm) {
      return this.vehicles; // Mostrar todos los datos si no hay búsqueda
    }

    const term = this.searchTerm.toLowerCase();
    return this.vehicles.filter(Infraccion => {
      // Ajusta los campos por los que quieres buscar

    });
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }

  listarGeneral(): void {
    this.vehicleService.getVehiclesGeneral().subscribe({
      next: (data) => {
        if (data?.vehicles ) {
          this.vehicles = data.vehicles.map((vehicle, index) => ({
            ...vehicle,
            
          }));
          this.filteredTableItems = this.vehicles; // ✅ Necesario para que funcione paginación y filtro
        }
      },
      error: (err) => console.error("Error cargando propietarios", err)
    });
  }
  
  estadoMap: { [key: string]: string } = {
    "VIGENTE": "badge badge-success",
    "POR VENCER": "badge badge-warning",
    "VENCIDO": "badge badge-secondary",
  };
  
  getEstadoColor(estado: string | undefined): string {
    return this.estadoMap[estado || ""] || "badge badge-light-primary"; // Si no hay estado, usa gris
  }


filterData() {
  const search = this.searchText?.toLowerCase() || ''; // Evita errores si searchText es null/undefined

  this.filteredTableItems = this.vehicles.filter((item) =>
    String(item.placa ?? '').toLowerCase().includes(search) ||
    String(item.tipoRelacion?.relacion ?? '').toLowerCase().includes(search)
  );

  this.page1 = 1; // Reinicia a la primera página al buscar
}


  
  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
 exportToPDF(tableId:string,nameFile:string,titleFile:string) {
  Utils.exportToPDF(tableId, nameFile,titleFile);
  }


  exportarExcel(tableId:string,nameFile:string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
 
  avisoInactivarPersona(placa: string) {
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar el vehículo con placa: ${placa}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.vehicleService.inactivateVehicle(placa).subscribe({
          next: (response) => {
            Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: response.message,
              confirmButtonText: 'Aceptar'
            });
            this.listarGeneral(); // 🔹 Solo refrescar si es exitoso
          },
          error: (error) => {
            console.error('Error:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.error?.message || 'No se pudo inactivar el vehículo',
              confirmButtonText: 'Aceptar'
            });
          }
        });
      }
    });
  }
  
  
  
  

  editarPersona(placa:string){
     this.router.navigate(['/vehiculo/editar-vehiculo', placa]);
   }

   CrearVehiculo() {
    this.router.navigate(['/vehiculos/nuevos']);
  }
  

   cargarDocumentos(numero:string){
    this.router.navigate(['/digitales/digitales']);
  }


    

   // Convertir imagen a Base64
   getBase64Image(imgUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imgUrl;
      img.crossOrigin = "Anonymous"; // Evita problemas de CORS

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png")); // Convertir a Base64
      };

      img.onerror = (error) => reject(error);
    });
  }

  
  

  
  
  
  
  
}
